import React, { useContext, useState } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getLabel } from '../../data/labels';
import { getConfiguration } from '../utils';

function BetslipButtons(props) {
    const conf = getConfiguration();
    const betslipContext = useContext(BetslipContext);
    
    const cartMessage = betslipContext.getCartMessage();

    const [action, setAction] = useState('buy');
    function doAction() {
        if (action == null) {
            return;
        } else if (action === 'reserve') {
            betslipContext.reserveTicket();
        } else {
            changeButtonState('confirm');
        }
    }

    function changeButtonState(buttonState) {
    	betslipContext.setPlayButtonState(buttonState);
    }

    function resetCart() {
    	changeButtonState('play');
    }

    const playButtonState = betslipContext.getPlayButtonState();
    const askForConfirmation = props.isLive ? conf.aclp : conf.acpp;
    
    return (
        <>
            <div className="betslip-message-container">
                {cartMessage != null &&
                    <div className={"betslip-message " + cartMessage.type}>
                        <div> {cartMessage.message} </div>
                    </div>
                }
            </div>
            { !betslipContext.isBetBuilder() &&
	            <div className="cart__footer__shopSelectorRow">
	                <div className="customInput customInput--radio">
	                    <label>
	                        <input type="radio" name="footerInputs" onChange={() => setAction('buy')} defaultChecked={true} />
	                        <span></span>
	                        <div className="customInput__description">{getLabel('betslip_alt.button.buy')}</div>
	                    </label>
	                </div>
	                <div className="customInput customInput--radio">
	                    <label>
	                        <input type="radio" name="footerInputs" onChange={() => setAction('reserve')} />
	                        <span></span>
	                        <div className="customInput__description">{getLabel('betslip_alt.button.reserve_ticket')}</div>
	                    </label>
	                </div>
	            </div>
            }
            <div className="cart__footer__betslipPlacementBtnsRow">
                {(!askForConfirmation || playButtonState === 'play' || playButtonState === 'again') && 
                    <div className="cart__footer__placementBtn cart__footer__placementBtn--placeBet clickable" onClick={doAction}>
                        {playButtonState === 'again'? getLabel('carrello.button.again') : getLabel('betslip_alt.button.place_bet')}
                    </div>
                }
                {askForConfirmation && playButtonState === 'confirm' &&
                    <>
                        <div className="cart__footer__placementBtn cart__footer__placementBtn--placeBet clickable" onClick={resetCart}>
                            {getLabel('carrello.go_back')}
                        </div>
                        <div className="cart__footer__placementBtn cart__footer__placementBtn--placeBet clickable" onClick={doAction}>
                            {getLabel('carrello.ok')}
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default BetslipButtons;
